module.exports = __webpack_public_path__ + "img/image_12.2d2bbb16.png";